import axios, { AxiosRequestConfig } from "axios";
import configs from "../config";

export type ErrorResponse = {
   message: string;
};

const TOKEN_KEY = "session_token";

export const setSessionToken = (token: string) => localStorage.setItem(TOKEN_KEY, token);
export const clearSessionToken = () => localStorage.removeItem(TOKEN_KEY);
export const getSessionToken = () => localStorage.getItem(TOKEN_KEY);

const axiosService = axios.create({
   baseURL: configs.API_BASE_URL,
});

axiosService.interceptors.request.use((config) => {
   const token = localStorage.getItem(TOKEN_KEY);
   if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
   }
   return config;
});

axiosService.interceptors.response.use(
   (response) => response,
   (error) =>
      Promise.reject(
         (error.response && error.response.data) || (error && error) || "Unspecified Error",
      ),
);

const post = async (resourceUrl: string, data?: any) => {
   return await axiosService.post(resourceUrl, data);
};

const postByConfig = async (resourceUrl: string, data?: any, config?: AxiosRequestConfig) => {
   return await axiosService.post(resourceUrl, data, config);
};

const get = async (resourceUrl: string, params?: Record<string, any>) => {
   return await axiosService.get(resourceUrl, params ? { params } : undefined);
};

const deleteAction = async (resourceUrl: string) => {
   return await axiosService.delete(resourceUrl);
};

const apiServices = {
   get,
   post,
   postByConfig,
   deleteAction,
};

export default apiServices;
